// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Json_decode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as OrderStatus from "../../../../../../library/data-source/order/entity/OrderStatus.bs.js";
import * as MapVehicleType from "../entity/MapVehicleType.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function getLocationLatLng(json) {
  return {
          lat: Json_decode.field("lat", Json_decode.$$float, json),
          lng: Json_decode.field("lng", Json_decode.$$float, json)
        };
}

function getRouteLocation(json) {
  return {
          point: Json_decode.field("latlng", getLocationLatLng, json),
          ts: Timestamp$Catalyst.make(Timestamp$Catalyst.secondsToMilliSeconds(Json_decode.field("ts", Json_decode.$$int, json)))
        };
}

function getDriverRoute(route) {
  if (route.length !== 0) {
    return {
            line: route
          };
  }
  
}

function noTimeLocationFormat(json) {
  return {
          location: {
            TAG: /* WithoutTime */1,
            _0: Json_decode.field("latlng", getLocationLatLng, json)
          },
          address: Json_decode.field("address", Json_decode.string, json)
        };
}

function execute(json) {
  var pickupTime = Json_decode.field("pickup_at", Json_decode.$$int, json);
  var acceptedTime = Json_decode.field("accepted_at", (function (param) {
          return Json_decode.optional(Json_decode.$$int, param);
        }), json);
  var tripStartedTime = Json_decode.field("trip_started_at", (function (param) {
          return Json_decode.optional(Json_decode.$$int, param);
        }), json);
  var tripEndedTime = Json_decode.field("trip_ended_at", (function (param) {
          return Json_decode.optional(Json_decode.$$int, param);
        }), json);
  var acceptedLocationFormat = function (json) {
    if (acceptedTime !== undefined) {
      return {
              TAG: /* WithTime */0,
              _0: {
                point: {
                  lat: Json_decode.field("lat", Json_decode.$$float, json),
                  lng: Json_decode.field("lng", Json_decode.$$float, json)
                },
                ts: Timestamp$Catalyst.make(Timestamp$Catalyst.secondsToMilliSeconds(acceptedTime))
              }
            };
    } else {
      return {
              TAG: /* WithoutTime */1,
              _0: {
                lat: Json_decode.field("lat", Json_decode.$$float, json),
                lng: Json_decode.field("lng", Json_decode.$$float, json)
              }
            };
    }
  };
  var pickupLocationFormat = function (json) {
    return {
            location: {
              TAG: /* WithTime */0,
              _0: {
                point: Json_decode.field("latlng", getLocationLatLng, json),
                ts: Timestamp$Catalyst.make(Timestamp$Catalyst.secondsToMilliSeconds(pickupTime))
              }
            },
            address: Json_decode.field("address", Json_decode.string, json)
          };
  };
  var tripStartedLocationFormat = function (json) {
    if (tripStartedTime !== undefined) {
      return {
              location: {
                TAG: /* WithTime */0,
                _0: {
                  point: Json_decode.field("latlng", getLocationLatLng, json),
                  ts: Timestamp$Catalyst.make(Timestamp$Catalyst.secondsToMilliSeconds(tripStartedTime))
                }
              },
              address: Json_decode.field("address", Json_decode.string, json)
            };
    } else {
      return {
              location: {
                TAG: /* WithoutTime */1,
                _0: Json_decode.field("latlng", getLocationLatLng, json)
              },
              address: Json_decode.field("address", Json_decode.string, json)
            };
    }
  };
  var tripEndedLocationFormat = function (json) {
    if (tripEndedTime !== undefined) {
      return {
              location: {
                TAG: /* WithTime */0,
                _0: {
                  point: Json_decode.field("latlng", getLocationLatLng, json),
                  ts: Timestamp$Catalyst.make(Timestamp$Catalyst.secondsToMilliSeconds(tripEndedTime))
                }
              },
              address: Json_decode.field("address", Json_decode.string, json)
            };
    } else {
      return {
              location: {
                TAG: /* WithoutTime */1,
                _0: Json_decode.field("latlng", getLocationLatLng, json)
              },
              address: Json_decode.field("address", Json_decode.string, json)
            };
    }
  };
  return {
          locations: {
            accepted_loc: Json_decode.optional((function (param) {
                    return Json_decode.field("accepted_loc", acceptedLocationFormat, param);
                  }), json),
            pickup_loc: Json_decode.field("pickup_loc", pickupLocationFormat, json),
            drop_loc: Json_decode.field("drop_loc", noTimeLocationFormat, json),
            trip_started_loc: Json_decode.optional((function (param) {
                    return Json_decode.field("trip_started_loc", tripStartedLocationFormat, param);
                  }), json),
            trip_ended_loc: Json_decode.optional((function (param) {
                    return Json_decode.field("trip_ended_loc", tripEndedLocationFormat, param);
                  }), json),
            waypoint_locs: Json_decode.optional((function (param) {
                    return Json_decode.field("waypoints", (function (param) {
                                  return Json_decode.array(noTimeLocationFormat, param);
                                }), param);
                  }), json)
          },
          driver_route: getDriverRoute(Json_decode.field("route", (function (param) {
                      return Json_decode.array(getRouteLocation, param);
                    }), json)),
          trip_started_time: Belt_Option.flatMap(tripStartedTime, (function (time) {
                  return Caml_option.some(Timestamp$Catalyst.make(Timestamp$Catalyst.secondsToMilliSeconds(time)));
                })),
          status: OrderStatus.fromString(Json_decode.field("order_status", Json_decode.string, json).toLowerCase()),
          vehicle_type: MapVehicleType.fromString(Json_decode.field("vehicle_icon_type", Json_decode.string, json))
        };
}

export {
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
